export const iconFontAwesomeMapsPaw = (
	<i className="fa-solid fa-paw"></i>
);
